import './styles.css';

export interface LoadingSpinnerProps {
    message?: string;
}

export default function LoadingSpinner({ message }: LoadingSpinnerProps) {
    return (
        <div className="loading-spinner-overlay">
            <div className="loading-spinner-container">
                <div className="spinner"></div>
                {message && <p className="loading-spinner-message">{message}</p>}
            </div>
        </div>
    );
}
